import {requestRemoteData} from '../../../API/api';
import {mapRemoteData} from '../../../common/domain/RemoteData.model';

const BANNER_ENDPOINT = 'offer';

/**
 * @returns {Promise<RemoteData<Banner>>}
 */
export const fetchAllBanners = () => {
  return requestRemoteData(BANNER_ENDPOINT).then(parseBanners);
};

const parseBanners = (rd) => {
  const mapperFn = banners => banners?.map(banner => ({
    // id: identificador ESTABLE para analitica (nombre es opcional en el admin y
    // puede venir vacio o duplicado); la imagen no vale, es URL firmada de 1 min.
    id: banner.id,
    title: banner.nombre,
    imageUrl: banner.imagen,
    link: banner.link,
    tipo: banner.tipo
  }))
  return mapRemoteData(rd, mapperFn);
};